import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './search_filters_radio_icon.module.scss';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';

type Props = {
  isSelected: boolean;
};

export const SearchFiltersRadioIcon: FC<Props> = ({ isSelected }) => (
  <MaterialIcon
    name={isSelected ? 'radio_button_checked' : 'radio_button_unchecked'}
    className={classNames(styles.container, {
      [styles.selected]: isSelected,
    })}
  />
);
